//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import BannerLeft from '~/static/roadblocks/bf-email-left.svg';
import BannerRight from '~/static/roadblocks/bf-email-right.svg';
import SubmitEmailMixin from '../../mixins/submit-email';

export default {
  mixins: [SubmitEmailMixin],
  data() {
    return {
      BannerLeft,
      BannerRight,
    };
  },
};
